'use strict';

function HowToCtrl(
  $scope,
  translations
) {
  $scope.translations = translations;
}

HowToCtrl.resolve = {
  translations: ['$translate', function($translate) {
    return $translate([
      'guide.markdown'
    ]);
  }]
};

module.exports = HowToCtrl;

angular.module('dokiv')
  .controller('HowToCtrl', [
    '$scope',
    'translations',
    HowToCtrl
  ]);



//////////////////
// WEBPACK FOOTER
// ./scripts/how-it-works/HowToCtrl.js
// module id = 69
// module chunks = 0